var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressMarkerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#FFF8ED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_12836)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_850_12836",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5H4.5V21H20.5V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_850_12836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5019 14.4463C11.0819 14.4463 9.92188 13.293 9.92188 11.8663C9.92188 10.4396 11.0819 9.29297 12.5019 9.29297C13.9219 9.29297 15.0819 10.4463 15.0819 11.873C15.0819 13.2997 13.9219 14.4463 12.5019 14.4463ZM12.5019 10.293C11.6352 10.293 10.9219 10.9996 10.9219 11.873C10.9219 12.7463 11.6286 13.453 12.5019 13.453C13.3752 13.453 14.0819 12.7463 14.0819 11.873C14.0819 10.9996 13.3686 10.293 12.5019 10.293Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5011 20.173C11.5144 20.173 10.5211 19.7997 9.74776 19.0597C7.78109 17.1663 5.60776 14.1463 6.42776 10.553C7.16776 7.29301 10.0144 5.83301 12.5011 5.83301C12.5011 5.83301 12.5011 5.83301 12.5077 5.83301C14.9944 5.83301 17.8411 7.29301 18.5811 10.5597C19.3944 14.153 17.2211 17.1663 15.2544 19.0597C14.4811 19.7997 13.4877 20.173 12.5011 20.173ZM12.5011 6.83301C10.5611 6.83301 8.06776 7.86634 7.40776 10.773C6.68776 13.913 8.66109 16.6197 10.4478 18.333C11.6011 19.4463 13.4077 19.4463 14.5611 18.333C16.3411 16.6197 18.3144 13.913 17.6077 10.773C16.9411 7.86634 14.4411 6.83301 12.5011 6.83301Z",
    fill: "#FFB600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_12836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressMarkerIcon);
export default __webpack_public_path__ + "static/media/address-marker-icon.540527a8b82191168ffd7f55dc420b04.svg";
export { ForwardRef as ReactComponent };